<template>
    <div class="space-y-1">
        <div class="grid grid-cols-5 gap-1">
            <form-button :color="logic.visible ? 'success' : 'theme'"
                title="Show or hide the event and action nodes of the active page (Shift+Tab cycles modes)"
                @click="logic.setVisible(!logic.visible)">Logic</form-button>
        </div>
        <!-- <p class="text-[10px] leading-tight text-gray-300">
            Click to add next to the selected object or event, or drag onto the canvas. Choose the exact event or action in the properties.
        </p> -->
        <div v-for="group in logic.palette" :key="group.id">
            <div class="mt-1 text-[10px] uppercase tracking-wide text-gray-300">{{ group.label }}</div>
            <div class="grid grid-cols-2 gap-1">
                <button v-for="entry in group.entries" :key="entry.id" type="button" draggable="true"
                    class="flex min-w-0 items-center gap-1 rounded px-1.5 py-0.5 text-left text-xs text-white shadow-sm hover:brightness-125"
                    :style="{ background: entry.color }"
                    :title="entry.title ?? entry.label"
                    @dragstart="onDragStart($event, entry)"
                    @click="$emit('add', entry)">
                    <span class="w-4 shrink-0 text-center">{{ entry.icon }}</span>
                    <span class="truncate">{{ entry.label }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useLogicStore } from '../../stores/logicStore.js';
import { LOGIC_PALETTE_MIME } from './paletteDrag.js';

defineEmits(['add']);
const logic = useLogicStore();

function onDragStart(event, entry) {
    event.dataTransfer.setData(LOGIC_PALETTE_MIME, entry.id);
    event.dataTransfer.effectAllowed = 'copy';
}
</script>
